import { Formik } from 'formik';
import { useMutation } from 'react-query';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { getApiMutation } from '../../../services/rest/getApiMutation';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { ModalWithStyles } from './ModalWithStyles';

export function DeleteSmsTemplateModal(props) {
  const mutation = useMutation(
    getApiMutation(props.userAtom, props.setUserAtom)
  );
  return (
    <Formik
      onSubmit={async (values, actions) => {
        if (props.selected.length) {
          for (let i = 0; i < values.selected.length; i++) {
            const data = {
              call: methodNameEnum.DELETE_SMS_TEMPLATE,
              apikey: props.userAtom.apikey,
              businessid: props.userAtom.businessid,
              smstid: values.selected[i].smsTemplateid,
              userid: props.currentUserBeingViewed.contents.id,
            };
            const response = await mutation.mutateAsync({
              endpoint: endpointEnum.DELETE_SMS_TEMPLATE,
              payload: data,
            });
            if (!response?.data?.success) {
              props.enqueueSnackbarWithStyles({
                message:
                  'Looks like we encountered an error deleting the SMS Template(s)',
                alertProps: { severity: 'warning' },
              });
              break;
            }
          }
          props.handleClose();
        }
        props.setRefetchToggleForSmsTemplates({});
        props.enqueueSnackbarWithStyles({
          message: 'Successfully Deleted SMS Template(s)',
          alertProps: { severity: 'success' },
        });
      }}
      enableReinitialize={true}
      initialValues={{
        selected: props.selected ?? [],
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Delete SMS Template(s)"
              aria-labelledby="example-modal-sizes-title-md"
              show={props.show}
              onHide={props.handleClose}
              isSubmitting={formik.isSubmitting}
              size={'xs'}
              deleteDialog={true}
            >
              <p>
                You are about to delete {formik.values.selected.length} SMS
                Template(s), this procedure is not reversible.
              </p>
              <p>Do you want to proceed?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
